import Links from "@/components/links";
import Download from "@/components/download";
import { Table1, Table2 } from "@/components/table";
import github from "assets/github.svg";
import x from "assets/x.svg";
import linkedin from "assets/linkedin.png";
import cv from "assets/cv.pdf";
import { Send, FileText } from "lucide-react";

const LINKS = [
	{ icon: { icon: Send, href: "mailto:elindstenz@outlook.com" } },
	{ image: { src: github, href: "https://github.com/novrion" } },
	{ image: { src: x, href: "https://x.com/novrion9" } },
	{ image: { src: linkedin, href: "https://linkedin.com/in/elias-lindstenz" } },
];

const PROJECT_TABLE_HEADER = ["Project", "Description"];
const PROJECT_TABLE_ITEMS = [
	{
		title: "MOSES",
		url: "https://github.com/novrion/MOSES",
		description: "simulation Model Of the Swedish Economic System",
	},
	{
		title: "Planning Survey",
		url: "https://github.com/novrion/Planning-Survey-Documentation",
		description: "documentation and C++ lib of a database of the Swedish industry",
	},
	{
		title: "awb.nvim",
		url: "https://github.com/novrion/awb.nvim",
		description: "neovim plugin for fast in-file AI assistance",
	},
	{
		title: "betabot",
		url: "https://github.com/novrion/betabot",
		description: "negamax bitboard chess engine, ~2000 ELO",
	},
	{
		title: "GYAR",
		url: "https://github.com/novrion/GYAR",
		description: "research efficiency of minimax chess engine optimisations",
	},
	{
		title: "tracktui",
		url: "https://github.com/novrion/tracktui",
		description: "TUI productivity tracker",
	},
	{
		title: "SIF website",
		url: "https://github.com/augie-sif/augustana-college-sif-website",
		description: "Augustana College Student Investment Fund website",
	},
	{
		title: "Gnosis",
		url: "https://github.com/kthaisociety/gnosis",
		description: "VLM evaluation platform specialised in oil documents",
	},
	{
		title: "code-jam",
		url: "https://github.com/novrion/code-jam",
		description: "framework for hosting coding tournaments",
	},
	{
		title: "MUON",
		url: "https://github.com/novrion/MUON",
		description: "Implementation of the MUON optimiser",
	},
];

const PAPERS_TABLE_HEADER = "Papers";
const PAPERS_TABLE_ITEMS = [
	{ text: "Documentation of The Planning Survey and Related Databases (2025)", url: "https://github.com/novrion/Planning-Survey-Documentation/blob/main/Documentation%20of%20The%20Planning%20Survey%20and%20Related%20Databases%20(2025).pdf" },
	{ text: "MOSES Conversion to Object Code (2025)", url: "https://github.com/novrion/MOSES/blob/MOSES-1989/MOSES%20Conversion%20to%20Object%20Code%20(2025).pdf" },
	{ text: "MOSES C++ Technical Specification (2025)", url: "https://github.com/novrion/MOSES/blob/MOSES-1989/MOSES%20C%2B%2B%20Technical%20Specification%20(2025).pdf" },
];

export default function Home() {
	return (
		<div className="flex flex-col items-center gap-6">
			{/* title */}
			<div>
				<h1 className="text-8xl text-center mt-4 select-none">
					Elias Lindstenz
				</h1>
				<div className="flex mt-1 gap-4 justify-center select-none ">
					<Links links={LINKS} />
					<Download icon={FileText} href={cv} filename="cv.pdf" />
				</div>
			</div>

			{/* description */}
			<div className="max-w-xl">
				<p>
					M.sc. in Engineering (Mathematics) at KTH Royal Institute of Technology. Software Engineer at <a href="https://lawline.se" className="font-semibold">Lawline</a>. Developer at <a href="https://kthais.com">KTH AI Society</a>. Ex engineer at <a href="https://strawberrybrowser.com/">Strawberry Browser</a>. Founder and CEO of Lindstenz Konsult AB.
				</p>

				<p className="mt-1">
					Loves Rust, C, C++, messing around with <a href="https://archlinux.org/">Linux</a>, well-made primitives like <a href="https://en.wikipedia.org/wiki/X_Window_System">X11</a> and <a href="https://wiki.archlinux.org/title/Bspwm">bspwm</a>, <span className="font-bold underline">brevity</span>, investing, tennis, playing the piano, and skiing.
				</p>
			</div>

			{/* projects */}
			<Table2 header={PROJECT_TABLE_HEADER} items={PROJECT_TABLE_ITEMS} className="max-w-xl" />

			{/* papers */}
			<Table1 header={PAPERS_TABLE_HEADER} items={PAPERS_TABLE_ITEMS} className="max-w-xl" />
		</div >
	);
}
